import React from 'react';
import ReactDOM from 'react-dom';


import './index.css';

import { CookiesProvider } from "react-cookie";
import App from './App';
import reportWebVitals from './reportWebVitals';



//import configureStore from "store";

import { createStore } from 'redux';


import { Provider } from 'react-redux'


import allReducers from './store/reducers';
//STORE
const myStore = createStore(allReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() );

//DISPLAY IN CONSOLE
//myStore.subscribe(() => console.log(myStore.getState()));




/*
const app = (  
   
      <App />
 
);

ReactDOM.render(<React.StrictMode>{app}</React.StrictMode>, document.getElementById('root'));*/

//https://medium.com/free-code-camp/how-to-set-up-twitter-oauth-using-passport-js-and-reactjs-9ffa6f49ef0


ReactDOM.render(
  <Provider store={myStore}>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
